module.exports = {
	getUser: function (app, force) {
		if (app.user && !force) {
			return Promise.resolve(app.user);
		} else {
			return app.$http.get('backend://auth/me').then((result) => {
				if (result.body.error) throw new Error(result.body.error);
				if (result.body.familyUser) {
					return app.$http.get('backend://family/' + result.body.familyUser.family).then((family) => {
						app.user = result.body;
						app.user.familyUser.family = family.body;
						app.user.refresh = this.getUser.bind(this, app, true);
						return app.user;
					});
				} else {
					app.user = result.body;
					app.user.refresh = this.getUser.bind(this, app, true);
					return app.user;
				}
			}).catch((error) => {
				app.$http.toastCatcher(error);
				return app.user;
			});
		}
	},

	loggedIn: function (app) {
		return this.getUser(app).then((user) => !!user);
	},

	logout: function (app) {
		return app.$http.get('backend://auth/logout').then((result) => {
			app.user = undefined;
			return true;
		}).catch((error) => {
			app.$http.toastCatcher(error);
			app.user = undefined;
			return true;
		});
	}
};



// WEBPACK FOOTER //
// ./src/auth.js